import { render, staticRenderFns } from "./Organizations.vue?vue&type=template&id=3e1a8438&scoped=true"
import script from "./Organizations.vue?vue&type=script&lang=ts"
export * from "./Organizations.vue?vue&type=script&lang=ts"
import style0 from "./Organizations.vue?vue&type=style&index=0&id=3e1a8438&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1a8438",
  null
  
)

export default component.exports